<template>
  <div class="tokkyo">
    <div class="pc"><a href="https://iranoan.site/25/" target="_blank"><img :src="`/img/${t('tokkyo.png')}`"></a></div>
    <div class="sp"><a href="/"><img class="sp_logo" :src="`/img/${t('logo.png')}?g=20221114`"></a></div>
    <div class="message">
      <div class="sp_title">24時間引ける<br>オンラインガチャ</div>
    </div>
  </div>
</template>

<script>
import t from '@/plugins/i18n';

export default {
  mixins: [t],
};
</script>

<style lang="scss" scoped>
.tokkyo {
  display: flex;
  .message {
    margin-left: 10px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    min-width: 150px;
    div {
      text-align: left;
      align-items: center;
      &:nth-child(1) {
        color: #fff;
        font-size: 15px;
        font-weight: bold;
      }
      &:nth-child(2) {
        color: #8B8B8B;
        font-size: 10px;
      }
    }
  }
  .sp_logo {
    width: 52px;
    margin-left: -7px;
  }
  img {
    height: 60px;
  }
}
.pc {
  display: block;
}
.sp {
  display: none;
}
@media screen and  (max-width: $tabletWidth) {
  .pc {
    display: none;
  }
  .sp {
    display: block;
  }
  .tokkyo {
    .message {
      line-height: 12px;
      min-width: auto;
      .sp_title {
        position: absolute;
        width: 100vw;
        text-align: center;
        left: 0;
      }
      div:nth-child(1) {
        font-size: 12px;
      }
    }
  }
}
</style>
